import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentDefinitionOverride,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';

import AuthenticationFieldEditor from './AuthenticationFieldEditor';

const mapStateToProps = state => {
  const currentOverride = currentDefinitionOverride(state);
  const fields = currentOverride?.authentication?.fields ?? [];

  const cliAppDefinitionEntity = currentAppDefinitionEntity(state);
  const { fieldKey } = RouterSelectors.getParams(state);

  return {
    initialAuthField: fields.find(({ key }) => key === fieldKey),
    isLoading: CliAppDefinition.selectors.isLoading(cliAppDefinitionEntity),
    isSaving: isCurrentAppDefinitionSaving(state),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch(DeveloperActions.loadAppAndVersion(id, version));
  },
  async upsertAuthField(authField, key) {
    return dispatch(DeveloperActions.upsertAuthField(authField, key));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(AuthenticationFieldEditor));
